import { httpGet, httpGetFile, httpPost_New } from './api.service';
import { PaginatedResult } from '../types/PaginatedResult';
import { PaginatedRequest } from '../requestModels/paginatedRequest';
import { ScanSession, SendScanReportRequest } from '../types/ScanSession';
import { ProcessStatus } from '../types/ProcessStatus';
import { BaseApiResponse } from '../types/BaseApiResponse';

const getSessions = async (request: PaginatedRequest): Promise<PaginatedResult<ScanSession>> => {
  return await httpGet<PaginatedResult<ScanSession>>(`api/scan`, request);
};

const exportSession = async (request: PaginatedRequest): Promise<void> => {
  return await httpGetFile(`api/scan/export`, request);
};

const getScanBySessionId = async (sessionId: string): Promise<PaginatedResult<ScanSession>> => {
  return await httpGet<PaginatedResult<ScanSession>>(`api/scan/${sessionId}`);
};

const getProcessStatusBySessionId = async (sessionId: string): Promise<BaseApiResponse<ProcessStatus>> => {
  return await httpGet<BaseApiResponse<ProcessStatus>>(`api/scan/${sessionId}/process-status`);
};

const sendScanReportToEmail = async (reportId: string, request: SendScanReportRequest): Promise<void> => {
  return httpPost_New(`api/scan/${reportId}/scanreport/share`, request);
};

export { getSessions, exportSession, getScanBySessionId, getProcessStatusBySessionId, sendScanReportToEmail };
